
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseSpinner',
  props: {
    alignLeft: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: undefined
    }
  },
  computed: {
    classes(): Record<string, boolean> {
      return {
        'base-spinner--align-left': this.alignLeft,
        'base-spinner--inline-block': this.inline
      };
    }
  }
});
